function ordinal_suffix_of(i) {
  const j = i % 10;
  const k = i % 100;
  if (j == 1 && k != 11) {
    return i + 'st';
  }
  if (j == 2 && k != 12) {
    return i + 'nd';
  }
  if (j == 3 && k != 13) {
    return i + 'rd';
  }
  return i + 'th';
}

function determineDeliveryDate({ days, startDate = new Date(), format = 'dayOfMonth', isBusinessDays = true }) {
  if (!days) return '';

  let deliveryDate;
  if (typeof startDate === 'string') {
    // ensure it's ISO-compatible
    const iso = startDate.includes('T') ? startDate : startDate.replace(' ', 'T');
    deliveryDate = new Date(iso);
  } else {
    // assume Date-like
    deliveryDate = new Date(startDate.getTime());
  }

  if (isBusinessDays) {
    let remaining = days;
    while (remaining > 0) {
      deliveryDate.setDate(deliveryDate.getDate() + 1);
      const dow = deliveryDate.getDay();
      if (dow !== 0 && dow !== 6) remaining--;
    }
  } else {
    deliveryDate.setDate(deliveryDate.getDate() + days);
  }

  if (format === 'dayOfMonth') {
    const day = ordinal_suffix_of(deliveryDate.getDate());
    const month = deliveryDate.toLocaleString('default', { month: 'long' });
    return `${day} of ${month}`;
  }

  if (format === 'iso') {
    // zero-out the time portion for consistency
    deliveryDate.setUTCHours(0, 0, 0, 0);
    return deliveryDate.toISOString();
  }

  return deliveryDate.toLocaleDateString('en-AU');
}

export default determineDeliveryDate;
